import React from "react";

const CTASection = () => {
  return (
    <section className="cta-section">

      <div className="cta-box">

        <h1>Let’s Build Something Exceptional Together</h1>

        <p>
          Partner with us to transform your
          digital vision into reality.
        </p>

        <button className="cta-btn">
          Request a Consultation
        </button>

      </div>

    </section>
  );
};

export default CTASection;